var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPretrazivanjePropisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 147.923 147.923",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.336,116.398c1.979,0.609,4.007,1.072,6.065,1.377c-3.021,8.427-11.016,14.516-20.46,14.516H21.824 C9.789,132.291,0,122.5,0,110.468V41.88c0-12.035,9.789-21.824,21.824-21.824h16.797C40.149,9.513,49.164,1.35,60.127,1.35h30.279 c12.032,0,21.823,9.789,21.823,21.824V38.04c-2.046-0.42-4.129-0.688-6.235-0.779V23.174c0-8.592-6.99-15.588-15.588-15.588H60.127 c-7.526,0-13.825,5.362-15.271,12.471h33.091c10.528,0,19.333,7.496,21.373,17.421c-2.058,0.25-4.086,0.701-6.107,1.267 c-1.449-7.097-7.745-12.453-15.259-12.453H21.836c-8.592,0-15.588,6.997-15.588,15.589v68.588c0,8.586,6.997,15.589,15.588,15.589 h56.118C84.433,126.05,89.998,122.049,92.336,116.398z M123.05,110.322c-17.993,10.388-41.077,4.201-51.462-13.786 C61.199,78.555,67.389,55.468,85.37,45.085c17.987-10.382,41.077-4.205,51.466,13.786 C147.224,76.855,141.025,99.934,123.05,110.322z M119.933,104.927c15.01-8.659,20.161-27.925,11.496-42.938 c-8.659-15.016-27.925-20.18-42.94-11.512c-15.013,8.668-20.168,27.925-11.503,42.94S104.916,113.592,119.933,104.927z  M132.513,108.008l-16.21,9.354l12.471,21.592l16.21-9.354L132.513,108.008z M146.664,132.535l-16.204,9.353 c2.582,4.481,8.306,6.017,12.775,3.423C147.711,142.729,149.258,137.011,146.664,132.535z M60.201,42.646H18.7v4.677h41.5V42.646z  M50.656,63.436H18.7v4.676h31.956V63.436z M18.7,88.895h31.956v-4.677H18.7V88.895z M18.7,109.676h41.5V105H18.7V109.676z  M98.133,84.188l-9.682-10.727l-4.628,4.187l13.695,15.149l26.755-22.283l-3.994-4.789L98.133,84.188z",
    stroke: "#231f20",
    strokeWidth: 3
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPretrazivanjePropisa);
export default __webpack_public_path__ + "static/media/PretrazivanjePropisa.1f9820bd22f59f490db91e1d272111bc.svg";
export { ForwardRef as ReactComponent };